import React, { useEffect, useState, useRef } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import {
  collection,
  doc,
  addDoc,
  onSnapshot,
  orderBy,
  query,
  serverTimestamp,
  setDoc
} from "firebase/firestore";
import { db } from "../firebase";

const ChatPage = () => {
  const { chatId } = useParams();
  const [searchParams] = useSearchParams();
  const hostId = searchParams.get("hostId");

  const currentUser = JSON.parse(localStorage.getItem("user"));
  const currentUserId = currentUser?.id;

  const [messages, setMessages] = useState([]);
  const [text, setText] = useState("");
  const bottomRef = useRef(null);

  // 🔹 LISTEN TO MESSAGES (same as RN)
  useEffect(() => {
    if (!chatId) return;

    const q = query(
      collection(db, "chats", chatId, "messages"),
      orderBy("createdAt", "asc")
    );

    const unsubscribe = onSnapshot(q, snapshot => {
      const msgs = snapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
      setMessages(msgs);
      setTimeout(() => bottomRef.current?.scrollIntoView(), 100);
    });

    return () => unsubscribe();
  }, [chatId]);

  // 🔹 SEND MESSAGE
  const sendMessage = async () => {
    if (!text.trim()) return;

    const chatRef = doc(db, "chats", chatId);

    await setDoc(
      chatRef,
      {
        participants: [currentUserId, hostId],
        updatedAt: serverTimestamp()
      },
      { merge: true }
    );

    await addDoc(collection(chatRef, "messages"), {
      text: text.trim(),
      fromId: currentUserId,
      toId: hostId,
      createdAt: serverTimestamp()
    });

    setText("");
  };

  return (
    <div className="chat-container">
      <div className="chat-header">Chat with Host</div>

      <div className="chat-messages">
        {messages.map(msg => (
          <div
            key={msg.id}
            className={`chat-bubble ${
              msg.fromId === currentUserId ? "me" : "other"
            }`}
          >
            <p>{msg.text}</p>
            <small>
              {msg.createdAt?.seconds
                ? new Date(msg.createdAt.seconds * 1000).toLocaleTimeString()
                : ""}
            </small>
          </div>
        ))}
        <div ref={bottomRef} />
      </div>

      <div className="chat-input">
        <input
          value={text}
          onChange={e => setText(e.target.value)}
          placeholder="Type a message"
        />
        <button onClick={sendMessage}>Send</button>
      </div>
    </div>
  );
};

export default ChatPage;
